import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ticket, Clock } from "lucide-react";
import { api } from "@/lib/api";

/* Live VIP-drop counter strip for the Landing page. Public (no auth). */
export default function VipDropStrip() {
  const [drop, setDrop] = useState(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/royai/vip/drop");
        if (alive) setDrop(data);
      } catch {
        /* silent */
      }
    };
    load();
    const t = setInterval(() => setTick((n) => n + 1), 1000);
    const s = setInterval(load, 30000);
    return () => {
      alive = false;
      clearInterval(t);
      clearInterval(s);
    };
  }, []);

  if (!drop) return null;
  void tick;
  const secondsToNext = Math.max(
    0,
    Math.floor((new Date(drop.next_drop_at).getTime() - Date.now()) / 1000),
  );
  const hms = `${String(Math.floor(secondsToNext / 3600)).padStart(2, "0")}:${String(
    Math.floor((secondsToNext % 3600) / 60),
  ).padStart(2, "0")}:${String(secondsToNext % 60).padStart(2, "0")}`;
  const soldOut = drop.remaining === 0;

  return (
    <div
      className="w-full border-y border-amber-500/20 bg-[#0a0a0a]"
      data-testid="landing-vip-drop-strip"
    >
      <div className="max-w-7xl mx-auto px-6 py-3 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <Ticket size={16} className="text-amber-500" />
          <div className="text-sm">
            {soldOut ? (
              <span className="text-neutral-300">
                VIP RoyAI invitations for today are <span className="text-red-400">closed</span>.
              </span>
            ) : (
              <span className="text-neutral-300">
                <span className="text-amber-500 font-semibold">VIP Access Only</span> · Request a
                60-Minute Invite Code inside RoyAI.
              </span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-3">
          {soldOut && (
            <span className="text-xs text-neutral-500 flex items-center gap-1.5 font-mono-tech">
              <Clock size={11} /> Next window in {hms}
            </span>
          )}
          <Link
            to="/royai"
            data-testid="landing-vip-claim-cta"
            className="inline-flex items-center gap-1.5 bg-amber-500 text-black px-3 py-1.5 text-xs font-semibold uppercase tracking-widest hover:brightness-110 transition-all"
          >
            {soldOut ? "See RoyAI" : "Request Invite"}
          </Link>
        </div>
      </div>
    </div>
  );
}
